import React from 'react';
import './addGig.css';
import TextInput from '../Common/TextInput';
import Button from '../Common/Button';

class AddGig extends React.Component {

    constructor() {
        super();
        this.state = {
            name: '',
            location: '',
            date: '',
            note: ''
        }
    }

    setName = (name) => {
        this.setState({ name });
    };

    setLocation = (location) => {
        this.setState({ location });
    };

    setDate = (date) => {
        this.setState({ date });
    };

    setNote = (note) => {
        this.setState({ note });
    };


    onSubmit = () => {
        this.props.onSubmit(this.state);
        this.setState({ location: '', date: '' });
    };

    render() {
        return (
            <div className="addGig">
                 <div className="addGig__name">
                    <label>Name</label>
                    <TextInput value={this.state.name} onChange={this.setName} />
                </div>
                <div className="addGig__location">
                    <label>Location</label>
                    <TextInput value={this.state.location} onChange={this.setLocation} />
                </div>
                <div className="addGig__date">
                    <label>Date</label>
                    <TextInput value={this.state.date} onChange={this.setDate} placeholder="DD/MM/YYYY"/>
                </div>
                <div className="addGig__notes">
                    <label>Notes</label>
                    <TextInput value={this.state.note} onChange={this.setNote} />
                </div>
                <div className="addGig__submitButton">
                    <Button type="button" onClick={this.onSubmit}>Submit</Button>
                </div>
            </div>
        );
    }
}  

export default AddGig;